import { sumBy } from 'lodash';
import moment, { Moment } from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../core/components/Loader';
import { useAppContext } from '../../../providers/AppProvider';
import { setFromDate, setUntilDate } from '../actions';
import { selectCombinedCountsWashes } from '../../wash-counts/reducer';
import { FETCH_CORE_COUNTS } from '../../wash-counts/actions';
import { getApiStatus } from '../../../core/utils';

interface Props {
  washCounts: { date: moment.Moment; count: number }[];
}

const DailyWashCountKpi = (props: Props) => {
  const dispatch = useDispatch();
  const controllerWashCounts: any[] = useSelector(selectCombinedCountsWashes);
  const fetchCoreCountsLoading = useSelector((state) => getApiStatus(state, FETCH_CORE_COUNTS));
  const intl = useIntl();
  const tz = useAppContext().timeZone;
  const changeDateRange = (date: Moment) => {
    const setTime = moment.tz(date, tz).toISOString();
    dispatch(setFromDate(moment.tz(setTime, tz).startOf('day')));
    dispatch(setUntilDate(moment.tz(setTime, tz).endOf('day')));
  };
  const dailyWashCountCards = () => {
    return props.washCounts ? (
      <React.Fragment>
        {props.washCounts
          .sort((a, b) => moment(a.date).diff(moment(b.date)))
          .map((washCount, i) => (
            <button
              key={i}
              className="col-md-2 col-sm-12 washed-card cars-washed"
              onClick={() => changeDateRange(washCount.date)}
            >
              <div className="daily-numbers">{washCount.count}</div>
              {moment(washCount.date).format('ddd, M/D')}
            </button>
          ))}
      </React.Fragment>
    ) : (
      <div className="powerbi-loading">
        <Loader />
      </div>
    );
  };

  const handleControllerWashCounts = () => {
    if (controllerWashCounts && !fetchCoreCountsLoading && controllerWashCounts.length > 0) {
      return sumBy(controllerWashCounts, 'runCount');
    }
    return <Loader />;
  };

  return (
    <section className="row-flex-inherit">
      <div className="col-md-2 col-sm-12 washed-card cars-washed-selected">
        <div data-testid="overview-hourly-total" className="daily-numbers">
          {handleControllerWashCounts()}
        </div>
        {intl.formatMessage({ id: 'selectedTotal' })}
      </div>
      <div className="scroll-container daily-cards">{dailyWashCountCards()}</div>
    </section>
  );
};

export default DailyWashCountKpi;
